/* LightSeek inquiry page — mirrors frontend/web app/inquiry */
(function () {
  'use strict';

  var cfg = window.LS_INQUIRY || {};
  var root = document.querySelector('.inq-page');
  if (!root) return;

  var STORAGE_KEY = 'lightseek-inquiry-products';
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  var products = load();
  var section = $('[data-inq-products]');
  var listEl = $('[data-inq-list]');

  function render() {
    if (!section || !listEl) return;
    section.hidden = products.length === 0;
    listEl.textContent = '';
    products.forEach(function (p) {
      var item = document.createElement('div');
      item.className = 'inq-product-item';

      var imageWrap = document.createElement('div');
      imageWrap.className = 'inq-product-image';
      var imageLink = document.createElement('a');
      imageLink.href = p.url || '#';
      var img = document.createElement('img');
      img.src = p.image || '';
      img.alt = p.name || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      imageLink.appendChild(img);
      imageWrap.appendChild(imageLink);

      var detail = document.createElement('div');
      detail.className = 'inq-product-detail';
      var nameLink = document.createElement('a');
      nameLink.className = 'inq-product-name';
      nameLink.href = p.url || '#';
      nameLink.textContent = p.name || '';
      var model = document.createElement('div');
      model.className = 'inq-product-model';
      model.textContent = 'Model NO.: ' + (p.model || '');
      var qty = document.createElement('div');
      qty.className = 'inq-qty';

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'inq-qty-btn inq-qty-minus';
      minus.textContent = '-';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.disabled = p.quantity <= 1;
      minus.addEventListener('click', function () {
        updateQuantity(p.id, Math.max(1, p.quantity - 1));
      });

      var input = document.createElement('input');
      input.type = 'number';
      input.min = '1';
      input.value = p.quantity;
      input.setAttribute('aria-label', 'Quantity');
      input.addEventListener('change', function () {
        updateQuantity(p.id, Math.max(1, Number(input.value) || 1));
      });

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'inq-qty-btn inq-qty-plus';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.addEventListener('click', function () {
        updateQuantity(p.id, p.quantity + 1);
      });

      qty.appendChild(minus);
      qty.appendChild(input);
      qty.appendChild(plus);

      detail.appendChild(nameLink);
      detail.appendChild(model);
      detail.appendChild(qty);

      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'inq-product-delete';
      del.setAttribute('aria-label', 'Remove product');
      del.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
      del.addEventListener('click', function () {
        products = products.filter(function (x) { return x.id !== p.id; });
        save(products);
        render();
      });

      item.appendChild(imageWrap);
      item.appendChild(detail);
      item.appendChild(del);
      listEl.appendChild(item);
    });
  }

  function updateQuantity(id, quantity) {
    products = products.map(function (p) {
      return p.id === id ? Object.assign({}, p, { quantity: quantity }) : p;
    });
    save(products);
    render();
  }

  render();

  /* ---------------- form ---------------- */
  var form = $('[data-inq-form]');
  var formBox = $('[data-inq-form-box]');
  var success = $('[data-inq-success]');
  var errorBox = $('[data-inq-error]');

  function setFieldError(field, message) {
    var wrap = $('[data-field="' + field + '"]');
    var text = $('[data-error="' + field + '"]');
    if (wrap) wrap.classList.toggle('inq-field--error', !!message);
    if (text) {
      text.textContent = message || '';
      text.hidden = !message;
    }
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var message = form.message.value.trim();
      var email = form.email.value.trim();
      var name = form.name.value.trim();
      var company = form.company.value.trim();
      var address = form.address.value.trim();
      var valid = true;

      setFieldError('message', '');
      setFieldError('email', '');
      setFieldError('name', '');
      if (errorBox) errorBox.hidden = true;

      if (!message) { setFieldError('message', 'Please enter your message'); valid = false; }
      if (!email) { setFieldError('email', 'Please enter your email'); valid = false; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setFieldError('email', 'Please enter a valid email address'); valid = false; }
      if (!name) { setFieldError('name', 'Please enter your name'); valid = false; }
      if (!valid) return;

      var submit = $('.inq-submit', form);
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Sending...';
      }

      var payload = {
        name: name,
        email: email,
        company: company,
        address: address,
        message: message,
        productId: products.map(function (p) { return p.id + ':' + p.quantity; }).join(',')
      };

      var done = function () {
        products = [];
        save(products);
        render();
        if (formBox) formBox.hidden = true;
        if (success) success.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      if (!cfg.endpoint) {
        if (submit) { submit.disabled = false; submit.textContent = 'Send Message'; }
        if (errorBox) {
          errorBox.textContent = 'Inquiry service is not configured. Please contact us by email.';
          errorBox.hidden = false;
        }
        return;
      }

      // text/plain keeps this a CORS "simple request"; the endpoint reads the JSON body.
      fetch(cfg.endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      }).then(done).catch(function () {
        if (submit) { submit.disabled = false; submit.textContent = 'Send Message'; }
        if (errorBox) {
          errorBox.textContent = 'Failed to send inquiry. Please try again.';
          errorBox.hidden = false;
        }
      });
    });
  }
})();
